import {
    APP_CLEAR,
    APP_INITIALIZED,
    AppDynamicParams,
    ClearAppAction,
    InitializeAppAction,
    LoadingState,
    ProductAccessAction,
    SelectedClassroomAction,
    SET_APP_DYNAMIC_PARAMS,
    SET_LOADING,
    SetAppDynamicParams,
    SetAppLoadingAction,
    UPDATE_APP_LOCALE,
    UPDATE_PRODUCT_ACCESS,
    UPDATE_SELECTED_CLASSROOM,
    UPDATE_SELECTED_PRODUCT,
    UpdateAppLocale,
    UpdateSelectedProductAction
} from './app.types';

export const initializeApp = (payload: InitializeAppAction['payload']): InitializeAppAction => {
    return {
        type: APP_INITIALIZED,
        payload
    };
};

export const updateSelectedProduct = (productId: number): UpdateSelectedProductAction => ({
    type: UPDATE_SELECTED_PRODUCT,
    payload: { productId }
});

export const updateSelectedClassroom = (payload: SelectedClassroomAction['payload']): SelectedClassroomAction => ({
    type: UPDATE_SELECTED_CLASSROOM,
    payload
});

export const clearApp = (): ClearAppAction => ({ type: APP_CLEAR });

export const updateProductAccess = (hasAccess: boolean): ProductAccessAction => ({
    type: UPDATE_PRODUCT_ACCESS,
    payload: { hasAccess }
});

export const updateAppLocale = (payload: UpdateAppLocale['payload']): UpdateAppLocale => ({
    type: UPDATE_APP_LOCALE,
    payload
});

export const setAppLoading = (payload: LoadingState): SetAppLoadingAction => ({
    type: SET_LOADING,
    payload
});

export const setAppDynamicParams = (payload: AppDynamicParams): SetAppDynamicParams => ({
    type: SET_APP_DYNAMIC_PARAMS,
    payload
});
